import { render, staticRenderFns } from "./ProductCardV5.vue?vue&type=template&id=0a4e6a96&"
import script from "./ProductCardV5.vue?vue&type=script&lang=js&"
export * from "./ProductCardV5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports